import React, {useMemo,useCallback} from "react";

const PaymentMethodSelector = ({savedCards = [], savedACH = [], onSelect, selected}) => {
 
  const paymentMethods = useMemo(() => [...savedCards.map((card) => ({
        id: card.id,
        type: "card",
        title: `**** **** **** ${card.card?.last4 || ""}`,
        subtitle: `${
          card.card?.brand?.toUpperCase() ||
          "CARD"
        } Card`,
      })),

      ...savedACH.map((bank) => ({
        id: bank.id,
        type: "bank",
        title:
          bank.us_bank_account?.bank_name ||
          "Bank Account",

        subtitle: `Account ending in ${
          bank.us_bank_account?.last4 || ""
        }`,
      })),
    ],
    [savedCards, savedACH]
  );

  const handleSelect = useCallback((id) => {
      if (id !== selected) {
        onSelect(id);
      }
    },
    [onSelect, selected]
  );

  if (!paymentMethods.length) {
    return (
      <div className="text-muted text-center py-3">
        No saved payment methods found.
      </div>
    );
  }

  return (
    <div className="saved-payment-list">
      {paymentMethods.map((method) => {
        const isSelected =
          selected === method.id;

        return (
          <div
            key={method.id}
            role="button"
            tabIndex={0}
            aria-pressed={isSelected}
            className={`saved-payment-card ${
              isSelected ? "active" : ""
            }`}
            onClick={() =>
              handleSelect(method.id)
            }
            onKeyDown={(e) => {
              if (
                e.key === "Enter" ||
                e.key === " "
              ) {
                handleSelect(method.id);
              }
            }}
          >
            <div className="saved-payment-left">
              <input
                type="radio"
                checked={isSelected}
                readOnly
              />

              <div className="saved-payment-details">
                <p className="payment-title mb-0">
                  {method.title}
                </p>

                <span className="payment-subtitle">
                  {method.subtitle}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(PaymentMethodSelector);